import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";
import { Alert } from './alert/alert';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertType, SnackBarModel } from './domain/snack-bar.model';

@Component({
  selector: "app-snack-bar",
  templateUrl: "./snack-bar.component.html",
  styleUrls: ["./snack-bar.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    Alert,
    TranslatePipe,
  ],
  standalone: true
})
export class SnackBarComponent implements OnInit {
  private data: SnackBarModel = inject(MAT_SNACK_BAR_DATA);
  public message!: string;
  public type!: AlertType;
  public withCloseIcon!: boolean;

  public ngOnInit(): void {
    this.message = this.data.message;
    this.type = this.data.type;
    this.withCloseIcon = this.data.withCloseIcon ?? false;
  }
}
